import { ComponentId, StepId } from "../../../constants";
export var selectCardStep = {
  id: StepId.YOUR_CC_SELECT_CARD,
  component: ComponentId.YOUR_CC_SELECT_CARD
};
export var successStep = {
  id: StepId.YOUR_CC_SUCCESS,
  component: ComponentId.YOUR_CC_SUCCESS
};
export var naStep = {
  id: StepId.YOUR_CC_NA,
  component: ComponentId.YOUR_CC_NA
};